import { useState } from 'react';

export function useCellPopover<T = any>() {
    const [showPopover, setShowPopover] = useState<boolean>(false);
    const [hoveredCell, setHoveredCell] = useState<HTMLElement | null>(null);
    const [hoveredCellHistoryList, setHoveredCellHistoryList] = useState<T | null>(null);

    const popoverOpen = (openPopover: boolean, cell: HTMLElement, list: T) => {
        setShowPopover(openPopover);
        setHoveredCell(cell);
        setHoveredCellHistoryList(list);
    };

    const popoverClose = () => {
        setHoveredCell(null);
    };

    return { showPopover, hoveredCell, hoveredCellHistoryList, popoverOpen, popoverClose };
}
